// Set second button addToCart after click open upselling suscription
let addButtonAtcOverlay;
const buttonGroup = document.querySelector('.product-form__buttons');
addButtonAtcOverlay = document.createElement('div');
buttonGroup.append(addButtonAtcOverlay);
addButtonAtcOverlay.classList.add('button-add-to-cart_trigger');

// Return logic add subscription product
function executeCodeWhenrechargeReadyExists() {
  const subscriptionRadios = document.querySelectorAll('.suscription__input');
  const bundleInfo = document.querySelector('script[data-bundle-json]');
  const bundleData = JSON.parse(bundleInfo.textContent);
  const bundleProductId = bundleData.variants[0].id;
  const bundleSellingPlan = bundleData.selling_plan_groups[0].selling_plans[0];
  const sellingPlanName = bundleSellingPlan.name;
  const sellingPlanId = bundleSellingPlan.id;
  let deliveryInfo = document.querySelector('.features__delivery');
  deliveryInfo.innerHTML = sellingPlanName;
  let checkStatusRadioSubscription = false;


  addSubscriptionBundle(bundleProductId, sellingPlanId);

  subscriptionRadios.forEach(function(radio) {
    radio.addEventListener('change', function(select) {
      if (this.checked) {
          subscriptionRadios.forEach(function(otherRadio) {
            if (otherRadio !== radio) {
              otherRadio.checked = false;
              otherRadio.classList.remove('active');
            }
          });
        radio.classList.add('active');
        if (radio.parentNode.parentNode.classList.contains('otp')) {
          checkStatusRadioSubscription = true;
          addButtonAtcOverlay.classList.add('active');
        }else{
          checkStatusRadioSubscription = false;
          addButtonAtcOverlay.classList.remove('active');
        }
        
      } else {
        radio.classList.remove('active');
      }
      document.statusInput = checkStatusRadioSubscription;
    });
  });
}

function addSubscriptionBundle(id, sellingPlanId) {
  const addBtn = document.querySelector('.product-form__submit');

  const handleClick = (event) => {
    const subscribeRadio = document.getElementById('subscribe');
    if (subscribeRadio.checked === true) {
      event.preventDefault();
  
      const quantity = document.querySelector('.quantity__input').value;
      const discountAmount = 2000
    
      const requestData = {
        items: [
          {
            id: id,
            quantity: quantity,
            selling_plan: sellingPlanId,
            properties: {
              '__discount': discountAmount
            }
          }
        ]
      };
    
      const requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
    
      const requestOptions = {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(requestData)
      };
    
      fetch('/cart/add.js', requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log('suscription pack added to cart: ', data);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          addBtn.removeEventListener('click', handleClick);
          addBtn.click();
          executeCodeWhenrechargeReadyExists();
        });
    }
  };

  addBtn.addEventListener('click', handleClick);
}

const observer = new MutationObserver(function(mutationsList) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const rechargeReady = window.Recharge;
      if (rechargeReady) {
        executeCodeWhenrechargeReadyExists();
        observer.disconnect(); 
        break;
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

window.validateIfDiscountActive = () => {
  const userCurrency = window.Shopify.currency;
  const currencySymbol = {
    USD: "$",
    EUR: "€",
    MXN: "$",
  };

  const compareSymbol = () => {
    return currencySymbol[userCurrency.active] ?? "€";
  };

  const discountElements = [... document.querySelectorAll('.suscription--pack__discount')];
  if (discountElements.length > 0) {
    const discountValues = discountElements.map(element => element.value);
    const totalDiscount = discountValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    // console.log('Current cart discounts: ' , Number(totalDiscount));

    fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      const cartTotal = cartData.total_price;
      const discountedCartTotal = String((Number(cartTotal) - Number(totalDiscount))/100).replace('.', ',') + compareSymbol();
      // console.log('Cart total with discount: ', discountedCartTotal);

      const valueToReplace = document.querySelector('.totals__subtotal-value span');
      valueToReplace.innerHTML = discountedCartTotal;

      document.cookie = `discount_code=NUEVO_SUSCRIPTOR; path=/`;
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  validateIfDiscountActive();
});

window.addEventListener('popstate', () => {
  validateIfDiscountActive();
});